import {
  KeyOutlined,
  LockOutlined,
  MessageOutlined,
  PlusOutlined,
  QrcodeOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import Entra from "../assets/Entra.png";
import SAML2 from "../assets/SAML2.png";
import OIDC from "../assets/OIDC.png";
import Ethernet from "../assets/settings_ethernet.png";
const RenderIcon = (mfaName) => {
  switch (mfaName) {
    case "password":
    case "Username and Password":
      return <LockOutlined />;
    case "passwordLess":
    case "Passwordless":
      return <UnlockOutlined />;
    case "Entra":
      return <img src={Entra} alt="Entra" />;
    case "SAML2":
      return <img src={SAML2} alt="SAML2" />;
    case "OIDC":
      return <img src={OIDC} alt="OIDC" />;
    case "PlusOutlined":
      return <PlusOutlined />;
    case "totp":
    case "TOTP":
      return <QrcodeOutlined />;
    case "sms":
    case "SMS":
      return <MessageOutlined />;
    case "Passkey":
      return <KeyOutlined />;
    case "settings_ethernet":
      return <img src={Ethernet} alt="Setting" />;
    default:
      return;
  }
};

export default RenderIcon;
